import { createElement, type ComponentProps } from 'react';

import { chakra } from '@plurall/elo-v3';

import { clsx } from '@/lib/formatters/classNames';

import { navIconRecipe, navLabelRecipe, navLinkRecipe, navSubitemLinkRecipe } from './local-navigation-entry-recipe';

const BaseNavLinkFactory = chakra('button', navLinkRecipe);

const BaseNavSubitemLinkFactory = chakra('button', navSubitemLinkRecipe);
const BaseNavLabelFactory = chakra('p', navLabelRecipe);
const BaseNavIconFactory = chakra('span', navIconRecipe);

export const NavButtonFactory = chakra('button');
export type NavLinkFactoryProps = ComponentProps<typeof BaseNavLinkFactory> & {
  isActive?: boolean;
};
export type NavSubitemLinkFactoryProps = ComponentProps<typeof BaseNavSubitemLinkFactory> & {
  isActive?: boolean;
};
export type NavLabelFactoryProps = ComponentProps<typeof BaseNavLabelFactory>;
export type NavIconFactoryProps = ComponentProps<typeof BaseNavIconFactory>;

export function NavLinkFactory({ isActive = false, className, ...props }: NavLinkFactoryProps) {
  return createElement(BaseNavLinkFactory, {
    ...props,
    isActive,
    className: clsx(className, 'local-navigation__link', isActive && 'local-navigation__link--active'),
  });
}

export function NavSubitemLinkFactory({ isActive = false, className, ...props }: NavSubitemLinkFactoryProps) {
  return createElement(BaseNavSubitemLinkFactory, {
    ...props,
    isActive,
    className: clsx(className, 'local-navigation__subitem-link', isActive && 'local-navigation__subitem-link--active'),
  });
}

export function NavLabelFactory({ className, ...props }: NavLabelFactoryProps) {
  return createElement(BaseNavLabelFactory, {
    ...props,
    className: clsx(className, 'local-navigation__label'),
  });
}

export function NavIconFactory({ className, ...props }: NavIconFactoryProps) {
  return createElement(BaseNavIconFactory, {
    ...props,
    className: clsx(className, 'local-navigation__icon'),
  });
}
